export var getIndexLastModified = function (state) {
    return state.systemLocal.lastModified;
};
export var getPreference = function (state, key, defaultValue) {
    var notPersistedResult = state.systemLocal.preferences[key];
    if (notPersistedResult !== undefined) {
        return notPersistedResult;
    }
    var persistedResult = state.systemLocal.preferencesLocalStorage[key];
    if (persistedResult !== undefined) {
        return persistedResult;
    }
    return defaultValue;
};
export var getPreferences = function (state, preferences) {
    return preferences.map(function (preference) { return ({
        key: preference.key,
        value: getPreference(state, preference.key, preference.defaultValue),
    }); });
};
